<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar" v-if="catInfo">
            <h1 class="bar-title">编辑百科分类</h1>
            <el-form class="form-container" :model="catInfo" :rules="catRules" ref="catInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">分类名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入分类名称"  v-model="catInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">分类层级</span>
                        <label class="warn">*</label>
                    </div>

                    <div class="form-input-item">
                        <el-form-item label="">
                            <el-input disabled v-if="catInfo.up_id==0" value="一级分类"></el-input>
                            <el-input disabled v-else value="二级分类"></el-input>
                        </el-form-item>
                    </div>
                </div>
                  <div class="form-item" v-if="catInfo.up_id!=0">
                    <div class="form-label">
                        <span class="label">上级分类</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item>
                            <el-input disabled v-model="catInfo.parent_category.name"></el-input>
                        </el-form-item>
                    </div>
                </div>
                  <div class="form-item">
                    <div class="form-label">
                        <span class="label">排序</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                         <el-form-item label="" prop="sort">
                            <el-input type="number"   v-model="catInfo.sort">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('catInfoForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import {editCategorie,categoriesLevelTwo } from '@/service/wikipedia'
    import PopoverRight from '@/components/popoverRight/index'
    export default {
        name: "baikeEdit",
        components: {
            PopoverRight
        },
        props: {
            callback: Function
        },
        
        data () {
            const validateSort = (rule, value, callback) => {
               if (/^-?\d+$/.test(value) === false || value > 9999 || value < -9999 || value === '-0') {
                    callback(new Error(`请输入-9999-9999之间的排序数字`))
                }else {
                    callback()
                }
            }
            return {
                catInfo:null,
                catRules: {
                    name: [
                        { required: true, message: '请填写名称', trigger: 'blur' },
                        { min: 1, max: 6, message: '长度在 1 到 6 个字符', trigger: 'blur' }
                    ],
                    sort: [
                      {validator: validateSort,trigger: "blur"}
                    ],
                },
            }
        },
        methods : {
          async open (row) {
                await categoriesLevelTwo(row.id).then(data => {
                    this.catInfo=data
                });
                 this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
           
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.$refs.catInfoForm && this.$refs.catInfoForm.clearValidate()
            },
            resetForm () {
                this.catInfo = null

            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                       
                        editCategorie(this.catInfo.id,this.catInfo).then((data) => {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback()
                        }).catch(err => {
                            const message = err.message
                            this.$message({
                                message: message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })

                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
